module.exports = __webpack_public_path__ + "img/treePlanting.2a165ea8.svg";